export const calculateDayTimeAvg = (times) => {
  if (!times.length) return undefined
  const minutes = times.reduce((p, c) => p + getTotalMinutes(c), 0)

  const minutesAvg = Math.round(minutes / times.length)
  return getDayTimeFromMinutes(minutesAvg)
}
const getTotalMinutes = (dayTime) => {
  if (!dayTime) return 0
  const [hours, minutes] = dayTime.split(':').map(Number)
  return hours * 60 + minutes
}

export const getDayTimeFromMinutes = (minutes) => {
  if (minutes < 0) return '00:00'
  const hoursAvg = Math.floor(minutes / 60)
  const minutesRest = minutes % 60
  return `${hoursAvg.toString().padStart(2, '0')}:${minutesRest.toString().padStart(2, '0')}`
}
